import { render } from "./BankAccountsAddTable.vue?vue&type=template&id=0f07ce14"
import script from "./BankAccountsAddTable.vue?vue&type=script&lang=ts"
export * from "./BankAccountsAddTable.vue?vue&type=script&lang=ts"
script.render = render

export default script